/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import SelectFromRest from '../../components/Form/SelectFromRest';
import { geoLocationStateActions, geoLocationStateConstants } from '../../modules/getlocationstate/actions';

import adescomStyle from 'assets/jss/adescom/adescomStyle';
import { store } from '../../core/store';
import { geoLocationStateReducers } from '../../modules/getlocationstate/reducers';

class GeoLocationStateSelectApi extends Component {
    constructor(props) {
        super(props);
        store.injectReducer('geoLocationStateReducers', geoLocationStateReducers);
        this.state = {
            geoLocationStateSelect: null,
        };
        this.handleSelectFunc = this.props.callbackSelect;
    }

    componentDidMount() {
        this.loadStateList();
    }

    loadStateList = () => {
        const { dispatch } = this.props;
        dispatch(geoLocationStateActions.getList(FormGeneralHelper.getUrl('/geo_location_states'), null, null, geoLocationStateConstants.LIST));
    };

    render() {
        const { geoLocationStateSelect, stateIdState, stateIdSelected, stateName } = this.props;
        return (
            <SelectFromRest
                callback={this.handleSelectFunc}
                required={true}
                restElements={geoLocationStateSelect}
                stateName={stateName}
                stateObjectState={stateIdState}
                selectedValue={stateIdSelected}
                propKey="id"
                propValue="stateName"
                addEmpty={true}
                displayEmpty={true}
                emptyLabel="general:common.choose_one"
                label="State"
            />
        );
    }
}

GeoLocationStateSelectApi.propTypes = {
    classes: PropTypes.object.isRequired,
    callbackSelect: PropTypes.func.isRequired,
    stateName: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    const { geoLocationStateReducers } = state;
    if (geoLocationStateReducers === undefined) {
        return { ...state };
    }
    let geoLocationStateSelect = null;
    if (geoLocationStateReducers.collections) {
        geoLocationStateSelect = geoLocationStateReducers.collections;
    }
    return {
        geoLocationStateSelect: geoLocationStateSelect,
    };
};

const geoLocation = compose(connect(mapStateToProps), withStyles(adescomStyle));
const GeoLocation = geoLocation(GeoLocationStateSelectApi);
export default GeoLocation;
